import Vue from 'vue'

// 转换百分数
Vue.filter('percent', (value, digits = 2, sign = true, showZero = true) => {
  if (
    value === undefined ||
    value === null ||
    value === '--' ||
    (value === 0 && !showZero)
  ) {
    return '--'
  }
  if (typeof value === 'string') {
    if (value.indexOf('+') === 0) {
      return value + '%'
    }
    if (value.indexOf('%') < 0) {
      return Number(value).toFixed(digits) + '%'
    }
    return value
  }
  // 需要在字符传之后再判断
  if (isNaN(value)) return '--'

  if (value === 0) {
    return '0.00%'
  }

  const displayValueLength = String(Math.abs(value) * 100).split('.')[0].length
  if (displayValueLength === 5) {
    digits = 0
  }
  if (displayValueLength === 4) {
    digits = 1
  }
  const num = (value * 100).toFixed(digits)
  return (parseFloat(num) > 0 && sign ? '+' : '') + num + '%'
})
